import React, { useState, useEffect } from 'react';
import { getProject, loadProject } from '../Store/Project';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
import { getDash, setSort, setSortDirection, setStage } from '../Store/Dash';
import { ProjectCard } from '../Models/ProjectCard';
import { getRoadmap } from '../Store/Roadmap';
import { format } from 'date-fns';
import { handleLoadComponent } from '../Helpers/handleLoadComponent';
import { getSettings } from '../Store/Settings';
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { IconBase } from 'react-icons';
import { useIsMobile } from '../Core/hooks';

function RoadmapDashWorkList() {

    const dispatch = useAppDispatch();
    let dashState = useAppSelector(getDash);
    let projectState = useAppSelector(getProject);
    let roadmapState = useAppSelector(getRoadmap);
    let settingsState = useAppSelector(getSettings);
    let [sort, setLocalSort] = useState("name");
    let [sortDirection, setLocalSortDirection] = useState("desc");
    const isMobile = useIsMobile();

    useEffect(() => {
        setLocalSort(dashState.sort);
        setLocalSortDirection(dashState.sortDirection);
    },[]);

    const showDetail = (stage: string) => {
        dispatch(setStage(stage));
    }

    const handleLoadProject = (e: React.MouseEvent<HTMLDivElement>, id: string) => {
        e.preventDefault();
        /* If project is already loaded, just switch to project screen, else load the project first */
        let project = projectState.projects.find(p => p.loaded);
        if (project && project._id === id) {
            handleLoadComponent(dispatch, "work", settingsState.settings);
        } else {
            dispatch(loadProject(id));
        }
    }

    const handleSort = (field: string) => {
        if (field === sort) {
            setLocalSortDirection((sortDirection === "asc") ? "desc" : "asc");
            dispatch(setSortDirection((sortDirection === "asc") ? "desc" : "asc"));
        } else {
            setLocalSort(field);
            setSortDirection("desc");
            dispatch(setSortDirection("desc"));
        }
        dispatch(setSort(field));
    }

    //let openColor = "#2e86c1";
    //let inProgressColor = "#e67e22";
    //let pausedColor = "#f4d03f";
    //let doneColor = "#138d75";
    //let canceledColor = "#2e4053";
    //let strategyColor = "#9b59b6";
    //let backgroundColor = "#fff";
    //let headerColor = "#fff";
    //let widthLeft = "40%";
    //let widthRight = "60%";
    //const WORK_FUNNEL = "workFunnel";
    //let cards = dashState.allProjectCardsInRoadmap;
    let cards: Array<ProjectCard> = dashState.allProjectCardsInRoadmap;

    if (dashState.selectedProjectId !== "") {
        cards = dashState.allProjectCardsInRoadmap.filter(card => {
            // find the list that this card belongs to
            const list = dashState.allProjectListsInRoadmap.find(list => list._id === card.listId);
            // include the card if the list belongs to the target project
            return list?.projectId === dashState.selectedProjectId;
        });
    }

    if (dashState.fromDate && dashState.toDate) {
        const from = new Date(dashState.fromDate);
        from.setHours(0, 0, 0, 0);
      
        const to = new Date(dashState.toDate);
        to.setHours(0, 0, 0, 0);
      
        cards = cards.filter(card => {
          const created = new Date(card.created);
          created.setHours(0, 0, 0, 0);
          const completed = new Date(card.statusChanged);
          completed.setHours(0, 0, 0, 0);
          if (card.status !== "Done"){
            return created >= from && created <= to;
          } else {
            return completed >= from && completed <= to;
          }
        });
    }

    let doneCards = cards
    .filter(c => c.status === "Done")
    .sort((a, b) => a.ownerId.localeCompare(b.ownerId));

    let totalActualWork = doneCards.reduce((sum, card) => {
        return sum + (card.actualWork || 0);
    }, 0);
    
    //let open = cards.filter(c => c.status === "Open");
    //let inProgress = cards.filter(c => c.status === "In Progress");
    //let paused = cards.filter(c => c.status === "Paused");
    //let done = cards.filter(c => c.status === "Done");
    //let canceled = cards.filter(c => c.status === "Canceled");
    //let strategy = cards.filter(c => c.status === "Strategy");

    /* Bar heights */

    //let scale = open.length;
    //scale = (inProgress.length > scale) ? inProgress.length : scale;
    //scale = (paused.length > scale) ? paused.length : scale;
    //scale = (done.length > scale) ? done.length : scale;
    //scale = (canceled.length > scale) ? canceled.length : scale;
    //scale = (strategy.length > scale) ? strategy.length : scale;

    //let openHeight = Math.ceil(open.length / scale * 100);
    //let inProgressHeight = Math.ceil(inProgress.length / scale * 100);
    //let pausedHeight = Math.ceil(paused.length / scale * 100);
    //let doneHeight = Math.ceil(done.length / scale * 100);
    //let canceledHeight = Math.ceil(canceled.length / scale * 100);
    //let strategyHeight = Math.ceil(strategy.length / scale * 100);
    

    //let details: Array<JSX.Element> = [];
    //let stage = dashState.stage;
    
    //let projectCards: Array<ProjectCard> = [];
    /*
    if (stage === "Open") {
        projectCards = open;
        backgroundColor = openColor;
    } else if (stage === "In Progress") {
        projectCards = inProgress;
        backgroundColor = inProgressColor;
    } else if (stage === "Paused") {
        projectCards = paused;
        headerColor = "#000";
        backgroundColor = pausedColor;
    } else if (stage === "Done") {
        projectCards = done;
        backgroundColor = doneColor;
    } else if (stage === "Canceled") {
        projectCards = canceled;
        backgroundColor = canceledColor;
    } else if (stage === "Strategy") {
        projectCards = strategy;
        backgroundColor = strategyColor;
    }
    */
    let sortNameIcon: any = (sort !== "name") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;
    let sortCardsCompletedIcon: any = (sort !== "cardsCompleted") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;
    let sortMinutesWorkedIcon: any = (sort !== "hoursWorked") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;
    let sortHoursPerCardIcon: any = (sort !== "hoursPerCard") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;
    let sortPercentIcon: any = (sort !== "percent") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;

    interface row {
        name: string;
        completedCards: number;
        hoursWorked: number;
        percent: string;
        hoursPerCard: number;
    }

    let rows: Array<row> = [];
    let savedOwnerId = "";
    let completedCards = 0;
    let minutesWorked = 0;
    let name = "";
    //let percent = "";
    //console.log(doneCards);
    doneCards.forEach((card, index) => {
        //console.log(savedOwnerId);
        //console.log(card.ownerId);
        if ((card.ownerId !== savedOwnerId && savedOwnerId !== "")) {
            rows.push({
                name: name,
                completedCards: completedCards,
                hoursWorked: parseFloat((minutesWorked / 60).toFixed(2)),
                percent: (minutesWorked / totalActualWork * 100).toFixed(2) + "%",
                hoursPerCard: minutesWorked / 60 / completedCards
            });
            name = "";
            completedCards = 0;
            minutesWorked = 0;
        }
        let member = roadmapState.members.find(m => m.userId === card.ownerId);
        if (member) {
            name = member.firstName + " " + member.lastName;
        }
        completedCards += (card.status === "Done") ? 1 : 0;
        minutesWorked += card.actualWork;
        savedOwnerId = card.ownerId;
    });

    if (savedOwnerId !== "") {
        rows.push({
            name: name,
            completedCards: completedCards,
            hoursWorked: parseFloat((minutesWorked / 60).toFixed(2)),
            percent: (minutesWorked / totalActualWork * 100).toFixed(2) + "%",
            hoursPerCard: minutesWorked / 60 / completedCards
        });
    }

    //console.log(rows);

    if (sort === "name") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => b.name.localeCompare(a.name));
        } else {
            rows.sort((a, b) => a.name.localeCompare(b.name));
        }
    } else if (sort === "cardsCompleted") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => b.completedCards - a.completedCards);
        } else {
            rows.sort((a, b) => a.completedCards - b.completedCards);
        }
    } else if (sort === "hoursWorked") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => b.hoursWorked - a.hoursWorked);
        } else {
            rows.sort((a, b) => a.hoursWorked - b.hoursWorked);
        }
    } else if (sort === "hoursPerCard") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => b.hoursPerCard - a.hoursPerCard);
        } else {
            rows.sort((a, b) => a.hoursPerCard - b.hoursPerCard);
        }
    } else if (sort === "percent") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => b.percent.localeCompare(a.percent));
        } else {
            rows.sort((a, b) => a.percent.localeCompare(b.percent));
        }
    }

    //let row = 0;
    
    let formattedRows = rows.map(card => {
        return (
            <div style={{ fontSize: "10pt", display: "flex", alignItems: "center",
                borderBottom: "1px solid #efefef", padding: "5px 0px"
                }}>
                <div style={{ width: isMobile ? "50%" : "20%", paddingRight: "5px" }}>
                    {card.name}
                </div>
                {!isMobile &&
                    <div style={{ width: "20%", cursor: "pointer", textAlign: "right" }}>
                        {card.completedCards.toLocaleString()}
                    </div>
                }
                <div style={{ width: isMobile ? "50%" : "20%", textAlign: "right" }}>
                    {card.hoursWorked.toLocaleString()}
                </div>
                {!isMobile &&
                <>
                    <div style={{ width: "20%", textAlign: "right" }}>
                        {card.hoursPerCard.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </div>
                    <div style={{ width: "20%", textAlign: "right" }}>
                        {card.percent}
                    </div>
                </>
                }
            </div>
        );
    });

    return (
        <div className="rightContentDefault" style={{ padding: "15px 25px", overflowY: "auto" }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{ width: "100%", backgroundColor: "#12354d", borderRadius: "30px",
                    color: "#fff", height: "22px", fontSize: "10pt", fontWeight: 400
                }}>
                    {rows.length} people
                </div> 

                <div style={{ verticalAlign: "top", textAlign: "left", marginTop: "20px" }}>
                    <div style={{ fontSize: "10pt", fontWeight: 550, padding: "5px 0px", borderBottom: "1px solid #efefef" }}>
                        <div style={{ display: "inline-block", width: isMobile ? "50%" : "20%", paddingRight: "5px" }} onClick={() => handleSort("name")}>
                            Name 
                            <span className="ps-2" style={{ cursor: "pointer" }}>
                                {sortNameIcon}
                            </span>
                        </div>
                        {!isMobile &&
                            <div style={{ display: "inline-block", width: "20%", textAlign: "right" }}  onClick={() => handleSort("cardsCompleted")}>
                                Cards Completed
                                <span className="ps-2" style={{ cursor: "pointer" }}>
                                    {sortCardsCompletedIcon}
                                </span>
                            </div>
                        }
                        <div style={{ display: "inline-block", width: isMobile ? "50%" : "20%", textAlign: "right" }} onClick={() => handleSort("hoursWorked")}>
                            Hours Worked
                            <span className="ps-2" style={{ cursor: "pointer" }}>
                                {sortMinutesWorkedIcon}
                            </span>
                        </div>
                        {!isMobile &&
                        <>
                            <div style={{ display: "inline-block", width: "20%", textAlign: "right" }} onClick={() => handleSort("hoursPerCard")}>
                                Hours Per Card
                                <span className="ps-2" style={{ cursor: "pointer" }}>
                                    {sortHoursPerCardIcon}
                                </span>
                            </div>
                            <div style={{ display: "inline-block", width: "20%", textAlign: "right" }} onClick={() => handleSort("percent")}>
                                % of Total
                                <span className="ps-2" style={{ cursor: "pointer" }}>
                                    {sortPercentIcon}
                                </span>
                            </div>
                        </>
                        }
                    </div>
                    {formattedRows}
                </div>
            </div>
        </div>
    );
}

export default RoadmapDashWorkList;
